var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "talk-bubble-wrapper",
      class: {
        "talk-bubble-own-post": _vm.ownComment,
      },
    },
    [
      !_vm.ownComment
        ? _c(
            "div",
            {
              staticClass: "talk-bubble-avatar",
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.userProfileURL,
                    title: _vm.comment.author["formatted-name"],
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.commentAvatar,
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "talk-bubble",
          class: {
            editing: _vm.editing,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "talk-bubble-content",
            },
            [
              !_vm.ownComment
                ? _c(
                    "header",
                    {
                      staticClass: "talk-bubble-header",
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.userProfileURL,
                          },
                        },
                        [_vm._v(_vm._s(_vm.comment.author["formatted-name"]))]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "talk-bubble-talktext",
                },
                [
                  !_vm.editing
                    ? [
                        _c("div", {
                          ref: "html",
                          staticClass: "html",
                          domProps: {
                            innerHTML: _vm._s(_vm.comment["content-html"]),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "talk-bubble-footer",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "talk-bubble-talktext-time",
                              },
                              [
                                _c("studip-date-time", {
                                  attrs: {
                                    timestamp: _vm.commentMkdate,
                                    relative: true,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.comment["is-writable"]
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "edit_comment",
                                    attrs: {
                                      href: "#",
                                      title: _vm.$gettext("Bearbeiten"),
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.editComment.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("studip-icon", {
                                      attrs: {
                                        shape: "edit",
                                        size: 14,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "answer_comment",
                                attrs: {
                                  href: "#",
                                  title: _vm.$gettext("Hierauf antworten"),
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    return _vm.answerComment.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "reply",
                                    size: 14,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    : _c(
                        "div",
                        {
                          staticClass: "talk-bubble-edit",
                        },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.localText,
                                expression: "localText",
                              },
                            ],
                            ref: "textarea",
                            domProps: {
                              value: _vm.localText,
                            },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.localText = $event.target.value
                                },
                                _vm.setTextareaSize,
                              ],
                              focus: _vm.setTextareaSize,
                              keydown: function keydown($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.saveComment.apply(null, arguments)
                              },
                              keyup: function keyup($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "escape",
                                    undefined,
                                    $event.key,
                                    undefined
                                  )
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.doneEditing.apply(null, arguments)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              attrs: {
                                title: _vm.$gettext("Speichern"),
                              },
                              on: {
                                click: _vm.saveComment,
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "accept",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              attrs: {
                                title: _vm.$gettext("Abbrechen"),
                              },
                              on: {
                                click: _vm.doneEditing,
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "decline",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                ],
                2
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }